<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Having a Christian background has greatly influenced her spiritual beliefs and deep-rooted faith. She grew up singing in the church choir and teaching Sunday school. Both her parents were ordained full-time ministers of the gospel. Driven by purpose, passion, and inspiration, she seeks to reach out to humanity through her writings. She believes we are all on a journey of new discoveries about the self, life, and spirituality.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?43998086